import { render, staticRenderFns } from "./DemoRequest.vue?vue&type=template&id=42d58860&scoped=true&"
import script from "./DemoRequest.vue?vue&type=script&lang=js&"
export * from "./DemoRequest.vue?vue&type=script&lang=js&"
import style0 from "./DemoRequest.vue?vue&type=style&index=0&id=42d58860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d58860",
  null
  
)

export default component.exports